import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import * as d3 from 'd3';
import { CompanyListService, DataSetItem } from '../company-list.service';

@Component({
  selector: 'app-general-statistics',
  templateUrl: './general-statistics.component.html',
  styleUrls: ['./general-statistics.component.scss'],
})
export class GeneralStatisticsComponent implements OnInit {
  @ViewChildren('chartRefs') chartRefs!: QueryList<ElementRef>;

  companiesDataset: DataSetItem[] = [];
  expirationsDataset: DataSetItem[] = [];
  personsDataset: DataSetItem[] = [];
  cardItems = [];
  chartsItems = [];
  loading = false;

  constructor(
    private companyListService: CompanyListService,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.loading = true;
    this.companyListService.getCompaniesStatistics().subscribe((res) => {
      this.companiesDataset = res.companiesDataset;
      this.expirationsDataset = res.expirationsDataset;
      this.personsDataset = res.personsDataset;
      this.cardItems = res.cardItems;

      this.chartsItems = [
        {
          title: 'STATS.COMPANIES',
          icon: 'view_compact_alt',
          ref: 'chartRef',
          list: this.companiesDataset,
          size: 150,
          center: 40,
        },
        {
          title: 'STATS.EXPIRATIONS',
          icon: 'schedule',
          ref: 'chartRef2',
          list: this.expirationsDataset,
          size: 150,
          center: 40,
        },
        {
          title: 'STATS.PERSONS',
          icon: 'people',
          ref: 'chartRef3',
          list: this.personsDataset,
          size: 150,
          center: 40,
        },
      ];

      this.loading = false;
      this.ref.markForCheck();

      this.chartRefs.changes.subscribe((refs: QueryList<ElementRef>) => {
        const refsEl = refs.toArray();
        refsEl.forEach((ref, index) => {
          this.createPieChart(
            this.chartsItems[index].size,
            this.chartsItems[index].list,
            this.chartsItems[index].center,
            ref.nativeElement
          );
        });
      });
    });
  }

  createPieChart(
    size: number,
    dataSet: { label: string; value: number; color: string }[],
    innerRadius: number,
    nativeElement
  ) {
    const data = dataSet;
    const width = size;
    const height = size;
    const radius = Math.min(width, height) / 2;

    const svg = d3
      .select(nativeElement)
      .append('svg')
      .attr('width', width)
      .attr('height', height)
      .append('g')
      .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');

    const color = d3
      .scaleOrdinal()
      .domain(data.map((d) => d.label))
      .range(data.map((d) => d.color));

    const pie = d3.pie<any>().value((d) => d.value);

    const arc = d3.arc<any>().innerRadius(innerRadius).outerRadius(radius);

    const arcs = svg
      .selectAll('arc')
      .data(pie(data))
      .enter()
      .append('g')
      .attr('class', 'arc');

    arcs
      .append('path')
      .attr('d', arc)
      .attr('fill', (d) => color(d.data.label))
      .attr('stroke', 'none');

    arcs
      .append('text')
      .attr('transform', (d) => {
        if ((d.data.value / d.data.total) * 100 < 5) {
          const pos = arc.centroid(d);
          const midAngle = Math.atan2(pos[1], pos[0]);
          const dx = Math.cos(midAngle) * (radius + 10); // Ajusta la distancia del texto al centro del arco
          const dy = Math.sin(midAngle) * (radius + 10); // Ajusta la distancia del texto al centro del arco
          return 'translate(' + dx + ',' + dy + ')';
        } else {
          return 'translate(' + arc.centroid(d) + ')';
        }
      })
      .attr('text-anchor', 'middle')
      .text((d) => `${d.data.value}`)
      .style('fill', 'black')
      .style('font-size', '12px');
  }
}
